import React from 'react';
import {
  ThemeProvider,
  TextField as DefaultTextField
} from '@ui-propulsion/react-components';
import { elementType, oneOfType, string } from 'prop-types';
import {
  CurrencyInput,
  DateInput,
  Input,
  MonthYearInput,
  PhoneInput,
  SSNInput,
  SelectInput,
  transformProps
} from '..';

const mapInput = {
  MonthYear: MonthYearInput,
  Input: Input,
  Currency: CurrencyInput,
  Date: DateInput,
  Phone: PhoneInput,
  SSN: SSNInput,
  Select: SelectInput
};

export const TextField = ({ component = 'Input', ...props }) => (
  <ThemeProvider>
    <DefaultTextField
      component={mapInput[component] || component}
      {...transformProps(props)}
    />
  </ThemeProvider>
);

TextField.propTypes = {
  component: oneOfType([string, elementType])
};

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/shared_modules/propulsion/components/TextField/TextField.scss');